import * as React from 'react';
import { FC } from 'react';

import { LockedOfferContainer, StyledLock } from './offer-lock.styled';

const OfferLocked: FC = props => (
  <LockedOfferContainer {...props}>
    <StyledLock fill={Styles.color.white} />
  </LockedOfferContainer>
);

export default OfferLocked;
